import { GTMPushEvent } from "@/src/helpers/google-tag-manager";

export const generateLabelTextForSearchboxGTMEventE6t = (locations, freeText) => {
  const convertedLocationsToLocationList = [];
  const locationKeys = Object.keys(locations);
  locationKeys.forEach((locationKey) => {
    if (locations[locationKey]) {
      if (locationKey === "city") {
        locations[locationKey].type = locationKey;
        locations[locationKey].id && convertedLocationsToLocationList.push(locations[locationKey]);
      } else if (locationKey !== "key" && locationKey !== "singleTown" && locationKey !== "singleDistrict") {
        locations[locationKey].forEach((location) => {
          location.type = locationKey;
          convertedLocationsToLocationList.push(location);
        });
      }
    }
  });
};

export const formGTMEventGA4 = ({ eventName, eventParameters = {} }) => {
  GTMPushEvent({
    event: "ga4_event",
    event_name: eventName,
    event_parameters: eventParameters,
  });
};

export const formGTMEventWithoutParametersGA4 = ({ eventName }) => {
  GTMPushEvent({
    event: "ga4_event",
    event_name: eventName,
  });
};

export const eCommerceGa4ListIds = {
  vitrin: "dTerPbhpe5a7V83RcNDPwj27Q0NDxajz",
  "ilan-listeleme": "iLU2nigQGrHn52hO6KkffbwPoVT3KM9j",
  "proje-listeleme": "5bf336b50c0743a1ddcb58dfa1133b56",
  "favori-listesi": "4s4LFZsLbE7FptsE8NTtHzH40ViV97sw",
  "ilan-detay": "5Lge38JIZmHDEInt1crj5dq5g5ZR3761",
  "emlak-ofisi-detay": "KKb02c9YMCNi47dkFxmLwCWdqdDyaDUc",
  "anasayfa/one-cikan-projeler": "1geiQM8veNB5oXAIORfMn1WLvCDTjvCz",
  "ilan-detay/benzer-ilanlar": "bnfJdnKiz7YjoGxKtBCmV1tOeKuva3ke",
  "proje-detay": "HJ6a7RLbSR2el3KPeAtV7AYNZJ8U21bP",
  "proje-detay/bolgedeki-projeler": "8sJZ2enQlse3XaLtCbPDDrGTwwaKbsjt",
  "ilan-detay/diger-ilanlar": "qe70KBcu1MKi7Vqs8U8ojkluVonjevXK",
  "arsa-ilanlari": "noM0GlIOTBIsRwcrmvw2dFZd00dUVOPw",
  "arsa-ilanlari/altyapisi-hazir": "gCp6dOGI8VJQk5HvdSF3P9a5u9HcBjwF",
  "arsa-ilanlari/one-cikanlar": "VdDkAkv8uoXFNSPwebP8rkbfyZdNBoiK",
  "arsa-ilanlari/sahibinden": "SYuicps5Es5RyEdJNCAL0PUvYnlGkbAn",
  "arsa-ilanlari/yatirima-uygun": "B2cL8LCYOBW72IinkdTEqoQNJbHmZfZj",
  "arsa-ilanlari/uc-d-sanal-tur": "cezNdU6MJmsXB27LqZFWCtpDKj439Rnv",
  "arsa-ilanlari/video": "CQAhjvWzD8HqKP96LEBkryXdnYuwfaJF",
  "arsa-ilanlari/fiyati-dusenler": "crXJYnetgyUEDTQqLhC7MRpk3fBWd9sP",
  "benzer-ilanlar": "A7b9K1m4Qz8xL2wP0vN5rY6cJ3hD7tF1sV8u",
  "ilan-listeleme/benzer-ilanlar": "A7b9K1m4Qz8xL2wP0vN5rY6cJ3hD7tF1sV8u",
};
